
import Location from "../../../assets/duotone/Location.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LocationIcon({ className, dataTestid = "LocationIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Location data-testid={dataTestid} className={classes} {...rest} />
  );
}
